document.addEventListener("algolia.hooks.initialize", () => {

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteConfigurationOptions",
    (config, context) => {

      // only target products
      if (context.sourceId === "products") {

        config.queries = config.queries.map((query) => ({

          ...query,

          params: {
            ...query.params,

            // exclude products having this tag
            filters: "NOT tags:private-maker"
          }

        }));
      }

      return config;
    }
  );

});

document.addEventListener("algolia.hooks.initialize", () => {

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteCollectionsTemplate",
    (html, data) => {

      const restrictedTemplates = [
        "new-category-collection",
        "new-maker-collection"
      ];

      if (restrictedTemplates.includes(data.item?.template_suffix)) {

        const hasMakerAccess = Array.isArray(window.customerTags) &&
          window.customerTags.includes("maker-access");

        if (!hasMakerAccess) {
          setTimeout(() => {
            const link = document.querySelector(
              `a.aa-ItemLink[href="/collections/${data.item.handle}"]`
            );

            if (link) {
              const li = link.closest("li");
              if (li) li.remove();
            }
          }, 0);
        }

      }

      return html;
    }
  );

});

// document.addEventListener("algolia.hooks.initialize", () => {

//   algoliaShopify.hooks.registerHook(
//     "beforeAutocompleteCollectionsTemplate",
//     (html, data) => {

//       if (data.item?.template_suffix === "new-category-collection") {

//         // Check if the logged-in customer has the "maker-access" tag
//         const hasMakerAccess = Array.isArray(window.customerTags) &&
//           window.customerTags.includes("maker-access");

//         // Only remove the result if they DON'T have the tag
//         if (!hasMakerAccess) {
//           setTimeout(() => {
//             const link = document.querySelector(
//               `a.aa-ItemLink[href="/collections/${data.item.handle}"]`
//             );

//             if (link) {
//               const li = link.closest("li");
//               if (li) li.remove();
//             }
//           }, 0);
//         }

//       }

//       return html;
//     }
//   );

// });

// document.addEventListener("algolia.hooks.initialize", () => {

//   algoliaShopify.hooks.registerHook(
//     "beforeAutocompleteCollectionsTemplate",
//     (html, data) => {

//       if (data.item?.template_suffix === "new-category-collection") {

//         setTimeout(() => {
//           const link = document.querySelector(
//             `a.aa-ItemLink[href="/collections/${data.item.handle}"]`
//           );

//           if (link) {
//             const li = link.closest("li");
//             if (li) li.remove();
//           }
//         }, 0);

//       }

//       return html;
//     }
//   );

// });

